'use client';

import { Link, SpriteIcon } from '@coolblue-development/freddy';
import selectAllAlternativesBelowElementTrigger from '@coolblue-development/ga4-events/triggers/AlternativePrimaryItem/selectAllAlternativesBelowElementTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';

import { stickyTitleStyles } from './BetterOptionsBlock.styled';

export const ComparisonLink = ({ productUrl }: { productUrl?: string }) => {
  const { t } = useTranslation('webshop');
  const { trackEvent } = useAnalytics();

  return (
    <Link
      href={productUrl}
      startIcon={<SpriteIcon name='arrow-right' />}
      ml={300}
      mt={300}
      pb={{ xs: 200, lg: 0 }}
      sx={stickyTitleStyles}
      rel='nofollow'
      onClick={() =>
        trackEvent(selectAllAlternativesBelowElementTrigger({ content: productUrl ?? '' }))
      }
    >
      {t('betterOptionsBlock.fullComparisonLink')}
    </Link>
  );
};
